"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _clsx = _interopRequireDefault(require("clsx"));

var _Radio = _interopRequireDefault(require("./Radio.style"));

var _Label = _interopRequireDefault(require("../Label"));

var _dec, _class;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

let Radio = (_dec = (0, _reactJss.default)(_Radio.default), _dec(_class = class Radio extends _react.PureComponent {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(value) {
    const {
      id,
      visibility,
      onChange
    } = this.props;
    if (visibility === 'disabled') return;
    const error = false;
    onChange({
      id,
      value,
      error
    });
  }

  render() {
    const {
      id,
      classes,
      className,
      helperText,
      error,
      label,
      value,
      children,
      visibility,
      align
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      id: id,
      className: (0, _clsx.default)(className, classes.radio, {
        hidden: visibility === 'hidden'
      }, {
        disabled: visibility === 'disabled'
      }, {
        horizontal: align === 'horizontal'
      })
    }, label ? /*#__PURE__*/_react.default.createElement("div", {
      className: classes.label
    }, label) : null, _react.default.Children.map(children, child => _react.default.cloneElement(child, {
      className: classes.item,
      activeItem: value,
      onChange: this.handleChange
    })), helperText && /*#__PURE__*/_react.default.createElement(_Label.default, {
      className: (0, _clsx.default)(classes.helperText, {
        error
      }),
      value: helperText,
      fontSize: "small",
      error: error
    }));
  }

}) || _class);
Radio.defaultProps = {
  id: null,
  value: null,
  visibility: 'visible',
  align: 'vertical',
  error: false,
  onChange: () => {}
};
var _default = Radio;
exports.default = _default;